"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLottie = _interopRequireDefault(require("react-lottie"));

var _searching = _interopRequireDefault(require("./searching.json"));

var _LoadingSearchCss = _interopRequireDefault(require("./LoadingSearch.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSearch = function LoadingSearch(_ref) {
  var onComplete = _ref.onComplete;
  var defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: _searching.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "loading-search",
    style: _LoadingSearchCss.default.loadingContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _LoadingSearchCss.default.loader
  }, /*#__PURE__*/_react.default.createElement(_reactLottie.default, {
    options: defaultOptions,
    eventListeners: [{
      eventName: 'complete',
      callback: function callback() {
        return onComplete();
      }
    }]
  })));
};

var _default = (0, _radium.default)(LoadingSearch);

exports.default = _default;

//# sourceMappingURL=LoadingSearch.jsx.map